import React from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
// eslint-disable-next-line camelcase
import { LEGACY_sendMessage } from '../../utils/legacy';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';

const S3Plugin = React.lazy(() => importFromS3('tcc-reports-plugin'));
const MFPlugin = React.lazy(() => import('tccReportsPlugin/TccReportsPlugin'));

export const ReportsPluginContainer = ({ operationsSelected }: { operationsSelected: Operation[] }) => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.reportsPlugin.module-federation'];

  const ReportsPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return (
    <ReportsPlugin
      // eslint-disable-next-line camelcase
      sendMessage={LEGACY_sendMessage}
      operationsSelected={operationsSelected}
      shouldRenderFarmerNav={false}
    />
  );
};
